import * as React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

const ReferAndEarnNavSolidIcon = (props) => (
  <SVGUniqueID>
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_279_1911)">
        <path
          d="M11.2744 6.96021C10.7974 7.30028 10.2136 7.50033 9.58317 7.50033C7.97234 7.50033 6.6665 6.19449 6.6665 4.58366C6.6665 2.97283 7.97234 1.66699 9.58317 1.66699C10.6273 1.66699 11.5433 2.21567 12.0586 3.04044M4.99984 16.7396H7.17508C7.45869 16.7396 7.74057 16.7734 8.01551 16.8409L10.3139 17.3994C10.8126 17.5209 11.3322 17.5327 11.8361 17.4348L14.3773 16.9404C15.0486 16.8096 15.6662 16.4882 16.1501 16.0174L17.9481 14.2684C18.4615 13.7698 18.4615 12.9607 17.9481 12.4612C17.4858 12.0115 16.7538 11.9609 16.2308 12.3423L14.1353 13.871C13.8352 14.0904 13.4701 14.2085 13.0945 14.2085H11.0711L12.3591 14.2085C13.085 14.2085 13.6731 13.6364 13.6731 12.9303V12.6746C13.6731 12.0882 13.2628 11.577 12.6782 11.4352L10.6903 10.9518C10.3668 10.8733 10.0355 10.8337 9.70245 10.8337C8.89845 10.8337 7.44308 11.4993 7.44308 11.4993L4.99984 12.5211M16.6665 5.41699C16.6665 7.02782 15.3607 8.33366 13.7498 8.33366C12.139 8.33366 10.8332 7.02782 10.8332 5.41699C10.8332 3.80616 12.139 2.50033 13.7498 2.50033C15.3607 2.50033 16.6665 3.80616 16.6665 5.41699ZM1.6665 12.167L1.6665 17.0003C1.6665 17.467 1.6665 17.7004 1.75733 17.8786C1.83723 18.0355 1.96471 18.1629 2.12151 18.2428C2.29977 18.3337 2.53313 18.3337 2.99984 18.3337H3.6665C4.13321 18.3337 4.36657 18.3337 4.54483 18.2428C4.70163 18.1629 4.82911 18.0355 4.90901 17.8787C4.99984 17.7004 4.99984 17.467 4.99984 17.0003V12.167C4.99984 11.7003 4.99984 11.4669 4.90901 11.2887C4.82911 11.1319 4.70163 11.0044 4.54483 10.9245C4.36657 10.8337 4.13321 10.8337 3.6665 10.8337L2.99984 10.8337C2.53313 10.8337 2.29977 10.8337 2.12151 10.9245C1.96471 11.0044 1.83723 11.1319 1.75733 11.2887C1.6665 11.4669 1.6665 11.7003 1.6665 12.167Z"
          stroke="currentColor"
          strokeWidth={1.66667}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_279_1911">
          <rect width={20} height={20} fill="white" />
        </clipPath>
      </defs>
    </svg>
  </SVGUniqueID>
);
export { ReferAndEarnNavSolidIcon };
